(function() {
	'use strict';

	angular.module('gatewayApp').service("workflowSharedService", function() {
		this.viewFrom = 'ManageCurrencyPairConfiguration'
	})

	.controller('ManageCurrencyPairConfigurationDialogController', ManageCurrencyPairConfigurationDialogController);

	ManageCurrencyPairConfigurationDialogController.$inject = [ '$scope', '$state',
			'workflowSharedService', 'ChangeConfig', 'GlobalValues',
			'EntityPermissions', 'ScreenLog', '$stateParams',
			'$uibModalInstance', '$rootScope', 'MessageBox', 'Workflow','entity','DateUtils', '$filter','AlertService','CurrencyPairConfiguration'];

	function ManageCurrencyPairConfigurationDialogController($scope, $state, workflowSharedService,
			ChangeConfig, GlobalValues, EntityPermissions, ScreenLog,
			$stateParams, $uibModalInstance, $rootScope, MessageBox, Workflow,entity,DateUtils, $filter,AlertService,CurrencyPairConfiguration) {

		var vm = this;
		vm.globalValues = GlobalValues;
		vm.screenLog = ScreenLog;
		vm.saveConfig = save;
		vm.confirmSave = confirmSave;
		vm.currecncyPairConfigSettings = {};
		vm.isShowDays = false;
		vm.isShowHours= false;
		vm.isShowSeconds= false;
		vm.isShowMins= false;
		vm.isShowUSD= false;
		vm.isShowPaise= false;
		vm.isShowPercentage=false;
		vm.errorText = "";
		vm.numericValueError = false;
		vm.isTransectionparamiter = false;
		vm.entityOwnerType = vm.globalValues.getEntityOwnerType().shortName;
		// vm.bankId = vm.globalValues.getBank().id;
		
		vm.approveCurrecncyPairConfigSettings = approveCurrecncyPairConfigSettings;
		vm.rejectCurrecncyPairConfigSettings = rejectCurrecncyPairConfigSettings;
		vm.discardCurrecncyPairConfigSettings = discardCurrecncyPairConfigSettings;
		vm.resubmitCurrecncyPairConfigSettings = resubmitCurrecncyPairConfigSettings;
		vm.clear = clear;
		$scope.showButton = false;
		$scope.isShowSaveButton = false;
		$scope.showDiscardButton = false;
		$scope.isShowResubmit = false;
		vm.isPasswordPolicySelected = true;

		vm.clicked = false;
		vm.noOfDecimals=0;


		if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_checker') {
			vm.ViewDisable = true;

			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.isDisabled = true
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			$scope.showButton = true;
			$scope.showDiscardButton = false;
			$scope.isShowResubmit = false;
			$scope.isShowSaveButton = false;

		} else if (workflowSharedService.viewFrom == 'currency_pair_configurationtodolist_maker') {
			vm.ViewDisable = true;
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		} else if (workflowSharedService.viewFrom == 'currency_pair_configuration_auditLog') {
			vm.ViewDisable = true;
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = true
			$scope.showButton = false;
			$scope.showDiscardButton = true;
			$scope.isShowSaveButton = false;
			$scope.isShowResubmit = false;
		}
		else if (workflowSharedService.viewFrom == 'currency_pair_configuration_todolist_resubmit') {
			vm.currecncyPairConfigSettings = angular.fromJson($rootScope.payload);
			vm.labelName = vm.currecncyPairConfigSettings.currencyPair.code;
			vm.bankId = vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.bankName = vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.currecncyPairConfigSettings.bank={};
			vm.currecncyPairConfigSettings.bank.id=vm.currecncyPairConfigSettings.bankId || $stateParams.bankId;
			vm.currecncyPairConfigSettings.bank.bankName=vm.currecncyPairConfigSettings.bankName || $stateParams.bankName;
			vm.isDisabled = false;
			$scope.isShowResubmit = true;
			$scope.isShowSaveButton = false;
		}else {
			vm.currecncyPairConfigSettings =  $stateParams.currencyPairConfig;
			vm.labelName = $stateParams.labelName;
			if( vm.currecncyPairConfigSettings.bank != null &&  vm.currecncyPairConfigSettings.bank != undefined){
			vm.bankId = vm.currecncyPairConfigSettings.bank.id;
			vm.bankName = vm.currecncyPairConfigSettings.bank.bankName;
			vm.currecncyPairConfigSettings.bankId = vm.currecncyPairConfigSettings.bank.id;
			vm.currecncyPairConfigSettings.bankName = vm.currecncyPairConfigSettings.bank.bankName;
			}

			vm.corpId = $stateParams.corpId;
			$scope.isShowSaveButton = true;
		}


		function confirmSave() {
			var action = vm.currecncyPairConfigSettings.isEnabled ? 'enable' : 'disable';
			var message;
			if (vm.corpId) {
				message = 'Do you want to ' + action + ' currency pair?';
			} else {
				message = 'Do you want to ' + action + ' currency pair for ' + vm.bankName + '?';
			}
			MessageBox.openMessageBox("Alert", message, "YesNo", "continueSave");
		}

		var yesListener = $rootScope.$on('gatewayApp.messagebox.yes.continueSave', function(event, result) {
			save();
		});
		
		var noListener = $rootScope.$on('gatewayApp.messagebox.no.continueSave', function(event, result) {
			// vm.clicked = false;
		});

		$scope.$on('$destroy', function() {
			if (yesListener) { yesListener(); }
			if (noListener) { noListener(); }
		});

		function save() {
			vm.currencyPairConfigurationDTO = vm.currecncyPairConfigSettings;
            if(vm.corpId){
                // Clearcorp mode: call /manage-currency-pair-configuration/{corpId}
                CurrencyPairConfiguration.update({
                    "corpId": vm.corpId
                }, vm.currencyPairConfigurationDTO, onSaveSuccess, onSaveError);
            } else {
                // Bank mode: call bank endpoint
                CurrencyPairConfiguration.bankupdate({
                    "corpId": GlobalValues.getCorpId()
                }, vm.currencyPairConfigurationDTO, onSaveSuccess, onSaveError);
            }
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}

		function onSaveSuccess(result) {
			$scope.$emit('Refresh');
			$uibModalInstance.close();

		}

		function onSaveError() {

			vm.clicked = false;
		}

		function approveCurrecncyPairConfigSettings() {
			CurrencyPairConfiguration.approve({
				"taskId" : $rootScope.taskID
			}, onApproveSuccess, onApproveError);
			
		}

		function onApproveSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
        }
		function onApproveError(error) {
			vm.clicked=false;
		}

		function rejectCurrecncyPairConfigSettings() {
			Workflow.rejectTask($rootScope.taskID);
		}

		function discardCurrecncyPairConfigSettings() {
			CurrencyPairConfiguration.discard({
				"taskId" : $rootScope.taskID
			}, onDiscardSuccess, onDiscardError);
			
		}

		function onDiscardSuccess(result) {

			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close();
		}
		function onDiscardError(error) {

		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.close(result);
			$uibModalInstance.close();
		}

		function onResubmitError(error) {
			vm.clicked=false;
		}

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function resubmitCurrecncyPairConfigSettings() {
			vm.currencyPairConfigurationDTO = vm.currecncyPairConfigSettings;
			CurrencyPairConfiguration.resubmitForCreate({
				"taskId": $rootScope.taskID
			}, vm.currencyPairConfigurationDTO, onResubmitSuccess, onResubmitError);
		}

	}
})();
